export { default as Img200 } from './processed/200/CultsAndExtremeBeliefs.jpg';
export { default as Img400 } from './processed/400/CultsAndExtremeBeliefs.jpg';
export { default as Imgthumb } from './processed/thumb/CultsAndExtremeBeliefs.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/CultsAndExtremeBeliefs.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/CultsAndExtremeBeliefs.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      137,
      103,
      60
    ],
    "_population": 16,
    "_hsl": [
      0.09307359307359309,
      0.39086294416243655,
      0.38627450980392153
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      101,
      76,
      44
    ],
    "_population": 6,
    "_hsl": [
      0.09356725146198831,
      0.3931034482758621,
      0.28431372549019607
    ]
  },
  "Muted": {
    "_rgb": [
      142,
      116,
      78
    ],
    "_population": 1201,
    "_hsl": [
      0.09895833333333331,
      0.2909090909090909,
      0.43137254901960786
    ]
  },
  "LightMuted": {
    "_rgb": [
      183,
      168,
      133
    ],
    "_population": 1893,
    "_hsl": [
      0.11666666666666664,
      0.2577319587628866,
      0.6196078431372549
    ]
  },
  "DarkMuted": {
    "_rgb": [
      79,
      73,
      59
    ],
    "_population": 2132,
    "_hsl": [
      0.1166666666666666,
      0.14492753623188404,
      0.2705882352941177
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/CultsAndExtremeBeliefs.js